<template>
    <div
        class="justify-center items-center py-1 px-2 text-xs text-gray-600 bg-gray-100 cursor-help"
        v-tooltip="$t('chat.messageInput.tooltipCount')"
    >
        {{ charactersCount }}/{{ segmentsCount }}
    </div>
</template>

<script>
    import SegmentedMessage from '@/vendors/segmentsCalculator.js';
    import GraphemeSplitter from '@/vendors/graphemeSplitter.js';
    import { shortnameToUnicode } from '@/utils/emoji.js';

    const graphemeSplitter = new GraphemeSplitter();

    export default {
        props: {
            message: {
                type: String,
                required: true,
            },
            file: {
                type: Boolean,
                default: false,
            },
        },

        computed: {
            unicodeMessage() {
                return shortnameToUnicode(this.message);
            },

            charactersCount() {
                return graphemeSplitter.countGraphemes(this.unicodeMessage);
            },

            segmentsCount() {
                const segmentedMessage = new SegmentedMessage(this.unicodeMessage, graphemeSplitter);
                const segmentCount = segmentedMessage.segments.length || 1;

                return this.file && segmentedMessage.segments.length ? segmentCount + 1 : segmentCount;
            },
        },
    };
</script>
